import React from 'react';

export default function ProviderDepositPolicyStepPage() {
  return (
    <div>
      <h2>Deposit policy</h2>
      <p>
        Set no-deposit, deposit-only, or full-prepayment rules per service in line with platform policy.
      </p>
    </div>
  );
}